import { queryClient } from 'App';

import { iaRa } from 'lib/helpers/utility';

export default async (data) => {
  const { note, patient_id } = data;
  queryClient.setQueryData(['sticky-notes', patient_id], (oldData) => {
    if (oldData) {
      const newNoteExists = iaRa(oldData?.notes).find((it) => it?.id === note.id);

      return {
        ...oldData,
        notes: newNoteExists ? iaRa(oldData?.notes) : [...iaRa(oldData?.notes), note]
      };
    }
  });
};
